module.exports = __webpack_public_path__ + "assets/img/btn-back-2d19f376.png";